module.exports = __webpack_public_path__ + "static/trig_012-2ce194aa091a3b6e36a4fcf8be1ea014.webp";